import React from 'react';
import {ReactComponent as AnswersIcon} from '../../../../../../../assets/main/test/response/answers.svg';
import {ReactComponent as CorrectAnswersIcon} from '../../../../../../../assets/main/test/response/correct-answers.svg';
import {useAppSelector} from "common/hook";
import {Skeleton} from 'antd';


export const ResponseTest = () => {
    const answersCount = useAppSelector(state => state.testViewAnswerId.serverData?.data?.answersCount);

    return (
        <div className="cards-statistic-box two-cols">
            <div className="card-statistic-item">
                <span className="icon">
                    <AnswersIcon/>
                </span>
                <p className="title h5">Ответы</p>
                <span className="num h3">
                    {answersCount?.answersAll === null && answersCount?.questionsAll === null ? (
                        <Skeleton.Input active={true}/>
                    ) : (
                        <span className="h4">{answersCount?.answersAll}/{answersCount?.questionsAll}</span>
                    )}
                </span>
            </div>
            <div className="card-statistic-item">
                <span className="icon">
                    <CorrectAnswersIcon/>
                </span>
                <p className="title h5">Правильные ответы</p>
                <span className="num h3">
                    {answersCount?.answersRight === null && answersCount?.questionsAll === null ? (
                        <Skeleton.Input active={true}/>
                    ) : (
                        `${answersCount?.answersRight}/${answersCount?.questionsAll}`
                    )}
                </span>
            </div>
        </div>
    );
};

